import { ScheduledSessionIcon } from 'src/components/icons'

import * as S from './styles'

export const SessionEndedTemplate = () => (
    <S.TemplateContent>
        <ScheduledSessionIcon />
        <S.TemplateDescription>The session has ended.</S.TemplateDescription>
    </S.TemplateContent>
)
